import { observer } from "mobx-react-lite";
import { useState } from "react";

import "./InvoiceSummary.scss";

import Button from "components/commons/Button/Button";
import ButtonInline from "components/commons/ButtonInline/ButtonInline";
import Info from "components/commons/Info/Info";
import AppStore from "stores/AppStore";
import InvoiceStore from "stores/InvoiceStore";
import SubmitKsefForm
    from "components/InvoiceComponents/InvoicePreview/components/InvoiceSummary/components/SubmitKsefForm/SubmitKsefForm";
import GenerateInvoiceModal from "./components/GenerateInvoiceModal/GenerateInvoiceModal";

const InvoiceSummary = () => {
    const [isGenerateModalVisible, setIsGenerateModalVisible] = useState(false);
    const {
        invoice: {
            invoiceData: {
                amounts: { gross }
            }
        }
    } = InvoiceStore;

    const {
        i18n: {
            invoicePreview: { generateInvoice },
            commons: { changeSettings }
        },
        setIsSettingsModalVisible
    } = AppStore;

    const handleGenerateInvoiceClick = () => {
        setIsGenerateModalVisible(true);
    };

    const onSubmitKsefNumber = async (values, { resetForm }) => {
        await InvoiceStore.uploadKsefNumberForActiveMonth(values.message);
        resetForm();
    };

    const renderButtons = () => {
        const infoText = (
            <>
                <ButtonInline
                    text={changeSettings}
                    onClick={() => {
                        setIsSettingsModalVisible(true);
                    }}
                />
            </>
        );

        return (
            <>
                <div className="c-invoice-summary__buttons">
                    <Button
                        text={generateInvoice}
                        className="c-invoice-summary__button"
                        onClick={handleGenerateInvoiceClick}
                    />
                </div>
                <div className="c-invoice-summary__form">
                    <SubmitKsefForm onSubmit={onSubmitKsefNumber} />
                </div>
                <div className="c-invoice-summary__info">
                    <Info gray text={infoText} />
                </div>
            </>
        );
    };

    return (
        <div className="c-invoice-summary">
            {!!gross.value && renderButtons()}

            <GenerateInvoiceModal
                isModalVisible={isGenerateModalVisible}
                onHideModal={() => {
                    setIsGenerateModalVisible(false);
                }}
            />
        </div>
    );
};

export default observer(InvoiceSummary);
